import { Injectable } from '@angular/core';

import { ClientConfigProductName, ProductService } from '@frontend/vanilla/core';

import { CasinoBootstrapService } from '../../bootstrap/casino-bootstrap.service';

@Injectable({
    providedIn: 'root',
})
export class CasinoProductService {
    constructor(
        private productService: ProductService,
        private casinoBootstrapService: CasinoBootstrapService,
    ) {}

    activateCasino(): void {
        this.productService.setActive(ClientConfigProductName.CASINO);
        this.casinoBootstrapService.activateStyleForCasino();
        dispatchEvent(new CustomEvent('gs:showHeaderEntry'));
        dispatchEvent(new CustomEvent('gs:showFloatingEntry'));
    }

    deactivateCasino(): void {
        this.productService.deactivateProduct(ClientConfigProductName.CASINO);
        this.casinoBootstrapService.deactivateStyles();
        dispatchEvent(new CustomEvent('gs:hideHeaderEntry'));
        dispatchEvent(new CustomEvent('gs:hideFloatingEntry'));
    }
}
